import React from "react";
import { Box, Button, Modal } from "../../libraries/material/core";

const createClasses  = () => {
    return {
        iframe: {
            height: "80vh",
            width: "100vh"
        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }
    }
};
function PDFModal(props = {}) {
    const classes = createClasses();

    return (
        <Modal open={props?.open} sx={classes.modal}>
            <div>
                <Button variant="contained" color="primary" onClick={props?.closeModal}   >
                    X
                </Button>
                <br />
                <Box component="iframe" sx={classes.iframe} src={props?.file} />
            </div>
        </Modal>
    );
}

export default PDFModal;